import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReportTitlePageData } from './report-title-page.utils';

@Component({
  selector: 'nk-report-title-page',
  imports: [TranslateModule],
  templateUrl: './report-title-page.component.html',
  styleUrls: ['./report-title-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportTitlePageComponent {
  public reportTitlePageData = input.required<ReportTitlePageData>();
}
